import { render } from "./IconTheChampion.vue?vue&type=template&id=7fc931fa&ts=true"
import script from "./IconTheChampion.vue?vue&type=script&lang=ts"
export * from "./IconTheChampion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__